// 模态框管理工具函数，需要弹出动态组件的页面引用
// import "@/utils/modalManager";

import Vue from "vue";
import vmodal from "@/plugins/modal";

Vue.use(vmodal, {
  dynamic: true,
  injectModalsContainer: true,
  clickToClose: false,
});

/**
 * 弹窗管理工具
 */
Vue.prototype.modalArray = [];
Vue.prototype.$showModal = function (component, settings, props, mark) {
  function beforeModalClose(event) {
    const index = Vue.prototype.modalArray.findIndex(
      (ele) => ele.instance.name === event.name
    );
    if (index > -1) {
      Vue.prototype.modalArray.splice(index, 1);
    }
  }

  function beforeModalOpen(event) {
    Vue.prototype.modalArray.push({
      instance: event,
      mark,
    });
  }

  Vue.prototype.$modal.show(
    component,
    props || {},
    {
      width: (settings && settings.width) || "400px",
      height: (settings && settings.height) || "500px",
      adaptive: true,
      maxWidth:
        (settings && settings.maxWidth) || document.body.clientWidth * 0.9,
      clickToClose: (settings && settings.clientWidth) || false,
      showClose: settings.showClose === false ? false : true,
      overlayTop: settings.overlayTop || 0,
      overlayLeft: settings.overlayLeft || 0,
      backgroundColor: settings.backgroundColor || "#fff",
      borderRadius: settings.borderRadius >= 0 ? settings.borderRadius : -1,
      root: this.$root,
    },
    {
      "before-close": function (event) {
        console.log(event);
        beforeModalClose(event);
        if (typeof settings.onClose === "function") {
          settings.onClose();
        }
      },
      "before-open": beforeModalOpen,
    }
  );
};

Vue.prototype.$hideModal = (mark) => {
  const index = Vue.prototype.modalArray.findIndex((ele) => ele.mark === mark);
  if (index > -1) {
    const name = Vue.prototype.modalArray[index].instance.name;
    Vue.prototype.$modal.hide(name);
  }
};

export default {
  showModal: Vue.prototype.$showModal,
  hideModal: Vue.prototype.$hideModal,
  $root: {},
};
